import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const AtlasLink = ({ geneSymbol }) => {
  return (
    <a
      href={getVarsoUrl(
        `http://genatlas.medecine.univ-paris5.fr/fiche.php?symbol=${geneSymbol}`
      )}
      target="_blank"
      className="varsome-gene-link"
    >
      GENATLAS
    </a>
  );
};

AtlasLink.propTypes = {
  geneSymbol: PropTypes.string,
};

AtlasLink.defaultProps = {
  geneSymbol: null,
};

export default AtlasLink;
